export const getExternalUrlOrRelativePath = ({
  isExternal,
  relativePath,
  url,
}: {
  isExternal: boolean;
  relativePath: Nullable<string | undefined>;
  url: Nullable<string | undefined>;
}) => {
  if (isExternal && url) {
    return url;
  }

  return relativePath ?? '';
};
